import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import ChipCards from '../dependencies/ChipCards/ChipCards';
import useShipmentBreakdown from './useShipmentBreakdown';

const ShipmentBreakdown = () => {
  const hook = useShipmentBreakdown();
  return (
    <Card
      sx={{
        p: 3,
        borderRadius: 3,
        boxShadow: 2,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography variant="body1" sx={{ fontWeight: 600, mb: '1.5rem' }}>
        Desglose de envíos: <strong>{hook.periodDate}</strong>
      </Typography>
      <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
        <Grid container alignItems="center" spacing={2} justifyContent="center">
          {hook.data?.data?.map((entry, index) => (
            <Grid size={{ xxs: 12, xl: 6 }} key={index}>
              <ChipCards
                key={index}
                color={colors[index]}
                text={entry.statusGroupES}
                quantity={entry.count}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Card>
  );
};

export default ShipmentBreakdown;

const colors = ['#5a8629', '#85c440', '#c7e4a8', '#2e4515', '#e8f4dc', '#e8f4dc'];
